import { HttpMethod } from '@pool-league/shared-util-http';
import {
  DeleteOperation,
  Endpoint,
  EndpointPathParameters,
  GetOperation,
  PatchOperation,
  PutOperation,
} from '../operation';

export type LeagueGetDivisionsPathParameters = EndpointPathParameters<
  'seasonId' | 'format'
>;

export const LEAGUE_GET_DIVISIONS: GetOperation<
  keyof LeagueGetDivisionsPathParameters
> = {
  path: [
    'seasons',
    { param: 'seasonId' },
    'league',
    { param: 'format' },
    'divisions',
  ],
  method: HttpMethod.GET,
};

export type LeagueGetDivisionPathParameters = EndpointPathParameters<
  'seasonId' | 'format' | 'division'
>;

export const LEAGUE_GET_DIVISION: GetOperation<
  keyof LeagueGetDivisionPathParameters
> = {
  path: [
    'seasons',
    { param: 'seasonId' },
    'league',
    { param: 'format' },
    'divisions',
    { param: 'division' },
  ],
  method: HttpMethod.GET,
};

export type LeagueResultPathParameters = EndpointPathParameters<
  'seasonId' | 'format' | 'division' | 'match'
>;

const LEAGUE_RESULT_PATH: Endpoint<keyof LeagueResultPathParameters> = [
  'seasons',
  { param: 'seasonId' },
  'league',
  { param: 'format' },
  'divisions',
  { param: 'division' },
  'matches',
  { param: 'match' },
];

export const LEAGUE_DELETE_RESULT: DeleteOperation<
  keyof LeagueResultPathParameters
> = {
  path: LEAGUE_RESULT_PATH,
  method: HttpMethod.DELETE,
};

export const LEAGUE_SAVE_RESULT: PutOperation<
  keyof LeagueResultPathParameters
> = {
  path: LEAGUE_RESULT_PATH,
  method: HttpMethod.PUT,
};

export interface SaveResultRequestBody {
  winner: string;
  result: 'F' | number;
}

export function isSaveResultRequestBody(
  value: unknown,
): value is SaveResultRequestBody {
  return (
    !!value &&
    typeof value === 'object' &&
    'winner' in value &&
    typeof value.winner === 'string' &&
    'result' in value &&
    (value.result === 'F' || typeof value.result === 'number')
  );
}
export type LeagueUpdatePlayoffPathParameters = EndpointPathParameters<
  'seasonId' | 'format' | 'playoff'
>;

export const LEAGUE_UPDATE_PLAYOFF: PatchOperation<
  keyof LeagueUpdatePlayoffPathParameters
> = {
  path: [
    'seasons',
    { param: 'seasonId' },
    'league',
    { param: 'format' },
    'playoff',
    { param: 'playoff' },
  ],
  method: HttpMethod.PATCH,
};

export type LeagueUpdatePathParameters = EndpointPathParameters<
  'seasonId' | 'format'
>;
export const LEAGUE_UPDATE: PatchOperation<keyof LeagueUpdatePathParameters> = {
  path: ['seasons', { param: 'seasonId' }, 'league', { param: 'format' }],
  method: HttpMethod.PATCH,
};
export type LeagueCreatePathParameters = EndpointPathParameters<
  'seasonId' | 'format'
>;
export const LEAGUE_CREATE: PutOperation<keyof LeagueCreatePathParameters> = {
  path: ['seasons', { param: 'seasonId' }, 'league', { param: 'format' }],
  method: HttpMethod.PUT,
};
